/* eslint-disable import/prefer-default-export */

import { getError } from '../../clientUtils';
import { showMessage } from '../../MessageHook';

// import message from '../..';
// import { getError } from '../../clientUtils';

// return Job status wrt to UI
const UI_JOB_STATUS = {
  uploading: 'UPLOADING_FILES',
  uploaded: 'FILES_UPLOADED',
  validating: 'VALIDATING',
  validated: 'VALIDATED',
  submitting: 'SUBMITTING',
  submitted: 'SUBMITTED',
  validationFailed: 'VALIDATION_FAILED',
  errorOnExecution: 'ERROR_ON_EXECUTION',
  submitFailed: 'SUBMIT_FAILED'
};

const POLLING_FREQ = 15000;

const TYPE_TITLE_MAP = {
  send_for_approval: 'Bulk Uploader Return Order Send for Approval',
  approve: 'Bulk Uploader Return Order Approve',
  reject: 'Bulk Uploader Return Order Rejection',
  mark_as_open: 'Bulk Uploader Return Order Mark as Open',
  dispatch: 'Bulk Uploader Return Order Dispatch',
  deliver: 'Bulk Uploader Return Order Deliver',
  inward_order_single: 'Bulk Uploader Return Order Inward Single',
  inward_order_group: 'Bulk Uploader Return Order Inward Group'
};

const SO_TYPE_TITLE_MAP = {
  dispatch: 'New Bulk SO Dispatch Request',
  deliver: 'New Bulk SO Deliver Request'
};

const JOB_NAMES = {
  send_for_approval: 'SEND_FOR_APPROVAL',
  approve: 'APPROVE',
  reject: 'REJECT',
  mark_as_open: 'OPEN',
  dispatch: 'DISPATCH',
  deliver: 'DELIVER',
  inward_order_single: 'CREATE_SINGLE_WMS_ORDER',
  inward_order_group: 'CREATE_GROUP_WMS_ORDER'
};

const TP_JOB_NAMES = {
  upload: 'CREATE',
  update: 'UPDATE'
};

const SO_JOB_NAMES = {
  dispatch: 'DISPATCH',
  deliver: 'DELIVER'
};

const JOB_TYPES = {
  validation: 'VALIDATION',
  submit: 'SUBMIT'
};

const JOB_STATUS_MAPPING = {
  CREATED: 'loading',
  STARTED: 'loading',
  SUCCESS: 'end',
  ERROR_ON_EXECUTION: 'end',
  WARNING: 'end',
  SUBMITTED: 'end',
  FAILED: 'end'
};

const SO_JOB_STATUS_MAPPING = {
  CREATED: 'loading',
  STARTED: 'loading',
  SUCCESSFUL: 'end',
  ERROR_ON_EXECUTION: 'end',
  WARNING: 'end',
  SUBMITTED: 'end',
  FAILED: 'end'
};

const EO_JOB_STATUS_MAPPING = {
  REQUEST_RECEIVED: 'loading',
  IN_PROGRESS: 'loading',
  SUCCESSFUL: 'end',
  FAILED: 'end'
};

const EO_JOB_STATUS = {
  requestReceived: 'REQUEST_RECEIVED',
  inProgress: 'IN_PROGRESS',
  successful: 'SUCCESSFUL',
  failed: 'FAILED'
};

const JOB_STATUS = {
  created: 'CREATED',
  'in-progress': 'IN_PROGRESS',
  started: 'STARTED',
  success: 'SUCCESS',
  errorOnExecution: 'ERROR_ON_EXECUTION',
  warning: 'WARNING',
  submitted: 'SUBMITTED',
  failed: 'FAILED'
};

const getCTAText = (jobStatus) => {
  const RUN_VALIDATION = [
    UI_JOB_STATUS.uploading,
    UI_JOB_STATUS.uploaded,
    UI_JOB_STATUS.validating,
    UI_JOB_STATUS.validationFailed
  ];
  if (RUN_VALIDATION.includes(jobStatus)) return 'Run Validation';
  return 'Submit';
};

const ifButtonDisabled = (jobStatus, validationSummary) => {
  if (jobStatus === UI_JOB_STATUS.validated) {
    if (validationSummary?.failure > 0) return true;
    return false;
  }
  if (jobStatus === UI_JOB_STATUS.uploaded) return false;
  return true;
};

const getJobType = (status, jobName, validationSummary) => {
  if (status === JOB_STATUS.errorOnExecution) return UI_JOB_STATUS.errorOnExecution;

  const nonTerminalStatus = [JOB_STATUS.created, JOB_STATUS.started, JOB_STATUS['in-progress']];

  if (jobName.includes('VALIDATE')) {
    if (nonTerminalStatus.includes(status)) return UI_JOB_STATUS.validating;
    let validationFailed = false;
    validationSummary.forEach((item) => {
      if (item.failure > 0) {
        validationFailed = true;
      }
    });

    if (validationFailed) return UI_JOB_STATUS.validationFailed;
    if (JOB_STATUS.submitted === status) return UI_JOB_STATUS.submitted;
    return UI_JOB_STATUS.validated;
  }

  if (jobName.includes('SUBMIT')) {
    if (nonTerminalStatus.includes(status)) return UI_JOB_STATUS.submitting;
    return UI_JOB_STATUS.submitted;
  }

  if (jobName.includes('PARSE')) {
    if (nonTerminalStatus.includes(status)) return UI_JOB_STATUS.submitting;
    return UI_JOB_STATUS.submitted;
  }

  return null;
};

const onError = (error) => showMessage().error(getError(error));

export {
  UI_JOB_STATUS,
  POLLING_FREQ,
  TYPE_TITLE_MAP,
  JOB_NAMES,
  JOB_TYPES,
  JOB_STATUS,
  JOB_STATUS_MAPPING,
  getCTAText,
  ifButtonDisabled,
  getJobType,
  onError,
  TP_JOB_NAMES,
  SO_TYPE_TITLE_MAP,
  SO_JOB_NAMES,
  SO_JOB_STATUS_MAPPING,
  EO_JOB_STATUS_MAPPING,
  EO_JOB_STATUS
};
